/**
 * Shared motion design tokens — smooth, restrained, consistent across the site.
 * Pair with `useMotionPreference()` for accessibility.
 */
export const EASE = [0.22, 1, 0.36, 1] as const

export const EASE_OUT = [0.16, 1, 0.3, 1] as const

export const DURATION = {
  fast: 0.32,
  base: 0.48,
  reveal: 0.56,
  page: 0.5,
} as const

/** Viewport preset for scroll-triggered reveals */
export const viewportReveal = {
  once: true,
  amount: 0.14,
  margin: '0px 0px -10% 0px',
} as const

export const viewportRevealTight = {
  once: true,
  amount: 0.08,
  margin: '0px 0px -6% 0px',
} as const

export const transition = {
  smooth: (duration: number = DURATION.base) => ({ duration, ease: EASE }),
  pageEnter: { duration: DURATION.page, ease: EASE },
  pageExit: { duration: 0.32, ease: EASE_OUT },
} as const

/** Page hero / staggered intros */
export const heroStaggerParent = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { delayChildren: 0.05, staggerChildren: 0.09 },
  },
}

export const heroStaggerItem = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: DURATION.reveal, ease: EASE },
  },
}

/** Footer columns */
export const footerBlockReveal = {
  hidden: { opacity: 0, y: 26 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.52, ease: EASE },
  },
}

export const footerColumnReveal = {
  hidden: { opacity: 0, y: 18 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.06, duration: 0.48, ease: EASE },
  }),
}
